function isValidHttpUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

function editValidate(values) {
  let errors = {};
  if (!values.otd_title) {
    errors.otd_title = "Please enter a OTD title";
  }
  if (!values.tagsStr) {
    errors.tagsStr = "Please enter a few file unders";
  }
  return errors;
}

function validate(values) {
  let errors = {};

  if (!values.otd_title) {
    errors.otd_title = "Please enter a OTD title";
  }

  if (!values.tagsStr) {
    errors.tagsStr = "Please enter a few file unders";
  }
  if (values.img_url && !isValidHttpUrl(values.img_url) && !values.img_url.startsWith(`/oftheday/otd_images/`)) {
    errors.img_url = "Please enter a valid image url";
  }
  if (values.link_url && !isValidHttpUrl(values.link_url)) {
    errors.link_url = "Please enter a valid link url";
  }

  if (!values.img_url && !values.link_url) {
    errors.link_url = "Please enter at least an image and/or link url";
  }
  return errors;
}

export { validate, editValidate };
